module.exports = __webpack_public_path__ + "static/media/spinning-circles.0f1a3f10.svg";